import React from "react"
import { usePageContext } from "vike-react/usePageContext"
import AldooAd from "aldoo-ra/AldooAds"
import ContentDistancer from "@components/Site/PricingPage/ContentDistancer"

// Per-placement wrapper styles. Implementing sites render
// `<AldooTransferBanner placement="..."/>` with no surrounding markup —
// sizing, margins and any decorative background live here. The banner
// content itself is a served Aldoo Ad (self-contained HTML from the
// connected Aldoo Transfer ad account), so creative changes happen in
// transfer's /admin/ads without touching this site.
const PLACEMENT_WRAPPER = {
  "home-ios":
    "w-full md:max-w-[630px] lg:w-[824px] lg:max-w-full xl:w-[892px] px-4 md:px-0 md:mt-[200px] mb-[160px] md:mb-[80px] mx-auto",
  "home-android":
    "w-full md:max-w-[630px] lg:w-[824px] lg:max-w-full xl:w-[892px] px-4 md:px-0 md:mt-[200px] mb-[160px] md:mb-[80px] mx-auto",
  pricing:
    "w-full md:max-w-[630px] lg:w-[824px] lg:max-w-full xl:w-[892px] bg-paper rounded-[24px] mx-4 lg:mx-0",
  "blog-article":
    "w-full md:max-w-[630px] lg:w-[824px] lg:max-w-full xl:w-[892px] my-24 md:my-28 lg:my-32 mx-auto",
  // Account page — sits in a max-w-[554px] column; the served asset is the
  // compact full-width profile banner.
  profile: "w-full",
}

const AldooTransferBanner = ({ placement }) => {
  // Server-side kill switch — ParamIO `ALDOO_TRANSFER_BANNER_CAMPAIGN`,
  // SSR-injected via pageContext. Hides every placement (incl. profile)
  // when explicitly false.
  const { aldooTransferBannerEnabled, aldooTransferAds } = usePageContext()
  if (aldooTransferBannerEnabled === false) return null

  // Placement → ad id map, ParamIO `ALDOO_TRANSFER_ADS` (SSR-injected):
  // { placements: { "home-ios": "<adId>", ... } }. Only the ad id is needed
  // (copied from the ads dashboard) — the local api resolves which connected
  // account serves it. Optional `account` narrows the lookup.
  const adId = aldooTransferAds?.placements?.[placement]
  const account = aldooTransferAds?.account
  if (!adId) return null

  const wrapperClass = PLACEMENT_WRAPPER[placement] || "w-full mx-auto"

  // Pricing surrounds the banner with a flex row (margins + ContentDistancer
  // spacer at xl). When the ad is unavailable the slot renders empty and the
  // section collapses with it.
  const banner = (
    <div className={wrapperClass}>
      <AldooAd id={adId} account={account} />
    </div>
  )

  return placement === "pricing" ? (
    <div className="relative flex justify-center items-start mt-[88px] md:mt-0 md:mb-[112px] xl:mb-[200px]">
      {banner}
      <ContentDistancer height="154px" />
    </div>
  ) : (
    banner
  )
}

export default AldooTransferBanner
